// @flow
import * as React from 'react';
import type { Element } from 'react';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import styled, { keyframes } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import theme from '@theme';

import type { Props } from './types';

const { colors } = theme;

const rotationKeyframe = keyframes`
  from {
      transform: rotate(0deg);
  }
  to {
      transform: rotate(359deg);
  }
`;

const StyledSpinner = styled(FontAwesomeIcon)`
  color: ${({ color }) => color};
  animation: ${rotationKeyframe} 2s infinite linear;
`;

const LoadingSpinner = ({ size = '5x', color = colors.darkBlue }: Props): Element<any> => (
  <StyledSpinner icon={faSpinner} size={size} color={color} />
);

export default LoadingSpinner;
